<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        :height="height"
        :top-height="topHeight"
        :title="title || 'Material'"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/Material/MaterialDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
<!--      <template v-slot:item.package="{ item }">-->
<!--        <span v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid]">-->
<!--          {{ storeAggregate.rootData[item.component_uid].article_display }}-->
<!--        </span>-->
<!--      </template>-->
      <template v-slot:item.package="{ item }">
        <span v-if="!!item.package">
          {{ item.package }}
        </span>
      </template>
      <template v-slot:item.component__article_display="{ item }">
        <span v-if="!!item.component_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.component_uid].article_display }}
        </span>
      </template>
      <template v-slot:item.component__alias="{ item }">
        <span v-if="!!item.component_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.component_uid].alias }}
        </span>
      </template>
      <template v-slot:item.material_owner__name="{ item }">
        <span
            v-if="!!item.material_owner_uid && storeAggregate.rootData && storeAggregate.rootData[item.material_owner_uid]">
          {{ storeAggregate.rootData[item.material_owner_uid].name }}
        </span>
      </template>
      <template v-slot:item.usage_restriction__name="{ item }">
        <span
            v-if="!!item.usage_restriction_uid && storeAggregate.rootData && storeAggregate.rootData[item.usage_restriction_uid]">
          {{ storeAggregate.rootData[item.usage_restriction_uid].name }}
        </span>
      </template>
      <template v-slot:item.material_delivery__provider__name="{ item }">
        <span
            v-if="!!item.material_delivery_uid && storeAggregate.rootData && storeAggregate.rootData[storeAggregate.rootData[item.material_delivery_uid].provider_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.material_delivery_uid].provider_uid].name }}
        </span>
      </template>
      <template v-slot:item.part_number__part_number="{ item }">
        <span
            v-if="storeAggregate.rootData && storeAggregate.rootData[item.part_number_uid]">
          {{ storeAggregate.rootData[item.part_number_uid].part_number }}
        </span>
      </template>
      <template v-slot:item.material_delivery__delivery_number="{ item }">
        <span v-if="!!item.material_delivery_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.material_delivery_uid].delivery_number }}
        </span>
      </template>
      <template v-slot:item.location__fullname="{ item }">
        <span v-if="!!item.location_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.location_uid].fullname }}
        </span>
      </template>
      <template v-slot:item.location__name="{ item }">
        <span v-if="!!item.location_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.location_uid].name }}
        </span>
      </template>
      <template v-slot:item.location__parent__name="{ item }">
        <span v-if="!!item.location_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.location_uid] &&
          !!storeAggregate.rootData[item.location_uid].parent_uid">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.location_uid].parent_uid].name }}
        </span>
      </template>
      <template v-slot:item.msl_timer="{ item }">
        {{ item.msl_timer_str }}
      </template>
      <template v-slot:item.lifecycle="{ item }">
        <MaterialLifecycleSelect :value="item.lifecycle" readonly></MaterialLifecycleSelect>
      </template>
      <template v-slot:item.pre_lifecycle="{ item }">
        <MaterialLifecycleSelect :value="item.pre_lifecycle" readonly></MaterialLifecycleSelect>
      </template>
      <template v-slot:item.msl_lifecycle="{ item }">
        <MslLifecycleSelect :value="item.msl_lifecycle" readonly></MslLifecycleSelect>
      </template>
      <template v-slot:item.pre_msl_lifecycle="{ item }">
        <MslLifecycleSelect :value="item.pre_msl_lifecycle" readonly></MslLifecycleSelect>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
      <template v-slot:footer.middle>
        <v-chip v-if="!!storeTable && !!storeTable.common && !!storeTable.common.data" outlined label>
          {{ $t('qty_on_page') }} = {{ storeTable.common.data.current_qty }}
        </v-chip>
        <v-spacer></v-spacer>
      </template>
      <template v-slot:top.bar.search.qsearch>
        <CommonSelectFromTable
                v-model="storeTable.quick_search"
                dto-list-query="ProviderListQueryDTO"
                store-name="SelectProvider"
                :sort-by="['name']"
                label="Provider, Owner or Used restriction"
                item-text="name"
                class="mt-6"
                background-color="lime lighten-4"
            >
            </CommonSelectFromTable>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import MaterialDetail from "@/components/CoreMaterial/Material/MaterialDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable.vue";
import MaterialLifecycleSelect from "@/components/CoreMaterial/Material/MaterialLifecycleSelect.vue";
import MslLifecycleSelect from "@/components/CoreMaterial/Material/MslLifecycleSelect.vue";

export default {
  name: "MaterialTable",

  props: {
    embedded: {default: false},
    title: {default: null},
    height: {default: null},
    topHeight: {default: 0},
    headers: {default: null},
    storeName: {type: [String], default: 'MaterialTable'},
    dtoDetailQuery: {default: 'MaterialDetailQueryDTO'},
    detailStoreName: {default: 'MaterialDetail'},
    dtoValidateCommand: {type: [String], default: 'MaterialValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonSelectFromTable,
    CommonTable,
    MaterialDetail,
    BaseFieldCheck,
    MaterialLifecycleSelect,
    MslLifecycleSelect,
  },

  computed: {},

  methods: {
    embeddedExportWithPartNumber(input_list) {
      console.log('embeddedExportWithPartNumber', input_list)
      let uidSelected = []
      this.storeTable.selected.forEach( row => uidSelected.push(row.uid))
      this.storeAggregate.fetchAction({
              storeName: this.storeName,
              dtoActionCommand: this.dtoActionCommand,
              // uidItem: this.uidItem,
              uidSelected: uidSelected,
              actionName: 'export_with_part_number',
              // actionUid: null,
              data: input_list,
              // callBack: null,
              // callReceive: null
            })
    },
    embeddedExportWithArticle(input_list) {
      console.log('embeddedExportWithArticle', input_list)
      let uidSelected = []
      this.storeTable.selected.forEach( row => uidSelected.push(row.uid))
      this.storeAggregate.fetchAction({
              storeName: this.storeName,
              dtoActionCommand: this.dtoActionCommand,
              // uidItem: this.uidItem,
              uidSelected: uidSelected,
              actionName: 'export_with_article',
              // actionUid: null,
              data: input_list,
              // callBack: null,
              // callReceive: null
            })
    }
  },

  mounted() {
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.options.itemsPerPage = 200
    this.storeTable.headers = this.headers || [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
      {text: 'Alias', value: 'component__alias', sortable: true, filterable: true, divider: true},
      {text: 'Material owner', value: 'material_owner__name', sortable: true, filterable: true, divider: true},
      {text: 'Usage restriction', value: 'usage_restriction__name', sortable: true, filterable: true, divider: true},
      {text: 'Provider', value: 'material_delivery__provider__name', sortable: true, filterable: true, divider: true},
      {text: 'Delivery number', value: 'material_delivery__delivery_number', sortable: true, filterable: true, divider: true},
      {text: 'P/N', value: 'part_number__part_number', sortable: true, filterable: true, divider: true},
      {text: 'Initial QTY', value: 'initial_qty', sortable: true, filterable: true, divider: true},
      {text: 'Current QTY', value: 'current_qty', sortable: true, filterable: true, divider: true},
      {text: 'Not used QTY', value: 'not_used_qty', sortable: true, filterable: true, divider: true},
      {text: 'Reservation quantity', value: 'reservation_quantity', sortable: false, filterable: true, divider: true, width: 40},
      {text: 'Supply type', value: 'supply_type', sortable: true, filterable: true, divider: true, width: 100},
      // {text: 'Package', value: 'package', sortable: true, filterable: true, divider: true, width: 40},
      // {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Location', value: 'location__name', sortable: true, filterable: true, divider: true, width: 100},
      // {
      //   text: 'Parent location',
      //   value: 'location__parent__name',
      //   sortable: true,
      //   filterable: true,
      //   divider: true,
      //   width: 100
      // },
      {text: 'Full location', value: 'location__fullname', sortable: false, filterable: true, divider: true, width: 170},
      {text: 'Status', value: 'lifecycle', sortable: true, filterable: true, divider: true, width: 170},
      // {text: 'Pre Lifecycle', value: 'pre_lifecycle', sortable: true, filterable: true, divider: true, width: 200},
      {text: 'MSL status', value: 'msl_lifecycle', sortable: true, filterable: true, divider: true, width: 170},
      // {text: 'Pre MSL Lifecycle', value: 'pre_msl_lifecycle', sortable: true, filterable: true, divider: true, width: 200},
      {text: 'MSL Timer', value: 'msl_timer', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'MSL level', value: 'msl_level', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'Thickness', value: 'thickness', sortable: false, filterable: true, divider: true, width: 30},
      {text: 'Sealed', value: 'sealed', sortable: true, filterable: true, divider: true, width: 20, type: 'bool'},
      // {text: 'Last change MSL timer', value: 'last_change_msl_timer', sortable: true, filterable: true, divider: true, width: 20, type: 'datetime'},
      {text: 'QR', value: 'qrcode', sortable: true, filterable: true, divider: true, width: 30, type: 'qrcode'},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['created_on']
    }
  },

  data() {
    return {
      storeAggregate: null,
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/CoreMaterial/locales.json">
</i18n>